var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.showOrder)?_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"询比单信息"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.orderInfo,"option":_vm.orderOptions,"el-attrs":{
          size: 'medium',
          column: 1,
          labelStyle: {
            width: '140px',
            whiteSpace: 'nowrap',
            textAlign: 'right'
          }
        }}})],1)]):_vm._e(),_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"流标处理"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.auctionInfo,"option":_vm.options,"el-attrs":{
          size: 'medium',
          column: 1,
          labelStyle: {
            width: '140px',
            whiteSpace: 'nowrap',
            textAlign: 'right'
          }
        }},scopedSlots:_vm._u([{key:"closeAttachmentIds",fn:function(){return [_c('upload',{ref:"uploadFile",attrs:{"file-id-before":_vm.auctionInfo.closeAttachmentIds,"props-data":{
              disabled: true,
              limit: 10,
              uploadMode: 'fileId',
              singleUpload: false
            }}})]},proxy:true},{key:"noticeContent",fn:function(){return [_c('u-editor',{attrs:{"disabled":""},model:{value:(_vm.auctionInfo.noticeContent),callback:function ($$v) {_vm.$set(_vm.auctionInfo, "noticeContent", $$v)},expression:"auctionInfo.noticeContent"}})]},proxy:true}])})],1)]),(_vm.requestQuery.pageFrom == 'auditDetail')?_c('record-remark',{attrs:{"remark-list":_vm.remarkList}}):_vm._e(),(_vm.requestQuery.pageFrom == 'auditDetail')?_c('record-history',{attrs:{"record-list":_vm.flowListing}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }